/**
 * 返回值Code值
 */
export enum ResultCodeEnum {
    /**
     * 成功
     */
    Success = 200,
    /**
     * 错误
     */
    Error = 400,
    /**
     * 未授权(未登录)
     */
    UnAuthorized = 401,
    /**
     * 无权访问
     */
    Forbidden = 403
}